module.exports = __webpack_public_path__ + "static/media/qd_monthly-report-4.a629ffa8.png";